<bic-popup (close)="cancelClicked()" customClass="w-[560px]" title="Modelle für BIM-Viewer auswählen">
  <div bicPopupContent class="flex flex-col gap-4">
    <span class="text-sm text-gray-500">Wählen Sie Modelle aus, die im BIM-Viewer geladen werden sollen</span>
    <div class="flex flex-col gap-1 max-h-64 overflow-y-auto border border-gray-200 rounded-lg p-2">
      <!-- Der Dialog geht bewusst sofort auf, bevor die Projektdateien da sind (siehe
           BimViewerService.onFileSelectRequested) -- ohne sichtbare Ladeanimation wirkt der
           Klick auf "IFC Öffnen" aber wie ein Klick ins Leere. -->
      @if (isLoadingFiles) {
        <div class="flex flex-row items-center gap-2 px-2 py-4 justify-center">
          <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
          <span class="text-sm font-medium text-gray-500">Modelle werden geladen…</span>
        </div>
      }
      <!-- Gespeicherte Koordinationsmodelle zuerst und optisch abgesetzt: sie stehen fuer mehrere
           Fachmodelle auf einmal. Vorher waren sie hier gar nicht auswaehlbar. -->
      @if (coordinationModels.length > 0) {
        <span class="text-xs font-medium text-gray-500 px-2 pt-1 pb-0.5">Koordinationsmodelle</span>
        @for (model of coordinationModels; track model.id) {
          <div (click)="toggleFile(model.id!)"
               class="flex items-center gap-3 px-2 py-1.5 rounded hover:bg-gray-50 cursor-pointer">
            <input (click)="$event.stopPropagation(); toggleFile(model.id!)"
                   [checked]="isSelected(model.id!)"
                   [type]="allowMultiple ? 'checkbox' : 'radio'"
                   class="w-4 h-4 rounded text-green-600 checked:bg-green focus:ring-0">
            <span class="text-sm text-gray-700 truncate">{{ model.name }}</span>
            <span class="text-xs text-gray-400 shrink-0">{{ linkedCount(model) }} Modelle</span>
          </div>
        }
        @if (ifcFiles.length > 0) {
          <span class="text-xs font-medium text-gray-500 px-2 pt-2 pb-0.5">Einzelmodelle</span>
        }
      }
      @for (file of ifcFiles; track file.id) {
        <div (click)="toggleFile(file.id!)"
             class="flex items-center gap-3 px-2 py-1.5 rounded hover:bg-gray-50 cursor-pointer">
          <input (click)="$event.stopPropagation(); toggleFile(file.id!)"
                 [checked]="isSelected(file.id!)"
                 [type]="allowMultiple ? 'checkbox' : 'radio'"
                 class="w-4 h-4 rounded text-green-600 checked:bg-green focus:ring-0">
          <span class="text-sm text-gray-700 truncate">{{ file.name }}</span>
        </div>
      }
      @if (!isLoadingFiles && hasLoadingError) {
        <span class="text-sm text-red-500 px-2 py-1.5">Dateien konnten nicht geladen werden.</span>
      }
      @if (!isLoadingFiles && !hasLoadingError && !hasSelectableFiles) {
        <span class="text-sm text-gray-400 px-2 py-1.5">Keine weiteren Modelle im Projekt vorhanden.</span>
      }
    </div>
    <div class="text-xs text-gray-500 px-1">
      {{ getSelectionLabel() }}
    </div>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
    <bic-button (onClick)="cancelClicked()" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="selectClicked()" [disabled]="isLoadingFiles || selectedIds.size < 1">Öffnen</bic-button>
  </div>
</bic-popup>
